module.exports = __webpack_public_path__ + "img/title-fish.a7dfe24.webp";